<router-outlet></router-outlet>
<app-pwa-install-prompt></app-pwa-install-prompt>
